// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6350 ? "72a30a16" : chunkId) + "." + {"2424":"5fe545b7760e424a","2442":"1592271f6df115e4","6339":"6c0b14162d84f8b6","6350":"20c8eca74efdc5a6","7499":"e328e320bf87a33e"}[chunkId] + ".js";
};